import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { useHasChanged } from '../../hooks/useHasChanged';
import { useSetAtomWithType } from '../../hooks/useSetAtomWithType';
import { formDisabledReasonAtom, formValidatedAtom } from './FormAtomsContext';

export function useFormValidated(): boolean {
	const validatedCount = useAtomValue(formValidatedAtom);
	return validatedCount > 0;
}

export function useUpdateFormValidated(): () => void {
	const count = useAtomValue(formValidatedAtom);
	const setCount = useSetAtomWithType(formValidatedAtom);

	const updateCount = useCallback(() => {
		setCount(count + 1);
	}, [count, setCount]);

	return updateCount;
}

export function useFormDisabled() {
	return useAtomValue(formDisabledReasonAtom);
}

export function useIsFormDisabled() {
	const value = useAtomValue(formDisabledReasonAtom);
	return value?.length > 0;
}

export function useSetFormDisabled() {
	return useSetAtomWithType(formDisabledReasonAtom);
}

export function useValidatedSinceMounted(): boolean {
	const count = useAtomValue(formValidatedAtom);
	const changed = useHasChanged(count);

	// Not validated
	if (count === 0) {
		return false;
	}

	// Validated since mounted
	return changed;
}
